import PropTypes from 'prop-types';
import React from 'react';
import dynamic from 'next/dynamic';
import { LocationsContext } from '@contexts/LocationsContext';
import { FindAHomeLocationIndicatorStyles } from './FindAHomeLocationIndicator.styled';
import LocationSelector from '@components/Shared/LocationSelector/LocationSelector';

const LocationButton = dynamic(
  () => import('@components/FindAHome/LocationButton'),
  { ssr: false }
);

const FindAHomeLocationIndicator = ({
  showLocationSelector,
  onPointerDown,
  onCloseLocationIndicatorClick,
  onPostalCodeChange,
  platform = 'Desktop',
}) => {
  return (
    <FindAHomeLocationIndicatorStyles>
      <LocationsContext.Consumer>
        {({ state, actions }) => {
          return (
            <>
              <LocationButton
                distance={state.distance}
                postalCode={state.postalCode}
                onPointerDown={onPointerDown}
              />

              {showLocationSelector && (
                <div className="location-selector-container">
                  <LocationSelector
                    applyButtonClassName="gtm-update-zip-home-listings"
                    locationKey={`findAHome${platform}`}
                    postalCode={state.postalCode}
                    distance={state.distance}
                    onUpdate={(...args) => {
                      actions.updateLocation(...args);
                      onPostalCodeChange();
                    }}
                    setUpdating={actions.setUpdating}
                    // pageOverlayVerticalOffsetInPixels={getVerticalOffsetForOverlay()}
                    onCloseClick={onCloseLocationIndicatorClick}
                  />
                </div>
              )}
            </>
          );
        }}
      </LocationsContext.Consumer>
    </FindAHomeLocationIndicatorStyles>
  );
};

FindAHomeLocationIndicator.propTypes = {
  onCloseLocationIndicatorClick: PropTypes.any,
  onPointerDown: PropTypes.any,
  onPostalCodeChange: PropTypes.any,
  platform: PropTypes.string,
  showLocationSelector: PropTypes.any,
};

export default FindAHomeLocationIndicator;
